import { useCallback, useEffect, useState } from "react";
import { ImportTemplate } from "@/types";
import { TemplateSelectorProps } from "./TemplateSelector";
import { getImportTemplates } from "@/api/ImportTemplate";

interface UseTemplateSelectorController {
  templates: ImportTemplate[];
  selectedTemplate?: ImportTemplate;
  selectTemplate: (id: number) => void;
}

export const useTemplateSelectorController = (
  props: TemplateSelectorProps
): UseTemplateSelectorController => {
  const [templates, setTemplates] = useState<ImportTemplate[]>([]);

  const loadTemplates = useCallback(async () => {
    const result = await getImportTemplates();
    setTemplates((prevState) => {
      if (JSON.stringify(result) !== JSON.stringify(prevState)) {
        return result;
      }
      return prevState;
    });
  }, []);

  const [selectedTemplate, setSelectedTemplate] = useState<
    ImportTemplate | undefined
  >(undefined);

  const selectTemplate = useCallback(
    (id: number) => {
      const match = templates.find(
        (template) => template.importTemplateId === id
      );
      if (match) {
        setSelectedTemplate(match);
        props.onSelectTemplate(id);
      }
    },
    [selectedTemplate, templates]
  );

  useEffect(() => {
    if (props.selectedTemplateId) {
      const template = templates.find(
        (template) => template.importTemplateId === props.selectedTemplateId
      );
      if (template) {
        setSelectedTemplate(template);
      }
    }
  }, [props.selectedTemplateId]);

  useEffect(() => {
    loadTemplates();
  }, []);

  return {
    templates: templates,
    selectedTemplate,
    selectTemplate,
  };
};
